import React from 'react'
import { connect } from 'react-redux'
import DateTime from 'react-datetime'
import moment from 'moment'
import SwitchButton from '../../Components/SwitchButton'
import Select from 'react-select'
import FilesActions from '../../Redux/FilesRedux'
import CouponActions from '../../Redux/CouponRedux'
import FileUploader from '../FileUploader'

class GenerateCoupon extends React.Component {
  constructor (props) {
    super(props)
    this.couponCodeRegex = /^[a-zA-Z0-9]*$/
    this.platforms = [
      { value: 'all', label: 'ALL' },
      { value: 'web', label: 'WEB' },
      { value: 'all-mobile', label: 'ALL-MOBILE' },
      { value: 'android', label: 'ANDROID' },
      { value: 'ios', label: 'IOS' }
    ]

    this.rentType = [
      { value: 'all', label: 'ALL' },
      { value: 'new', label: 'NEW' },
      { value: 'topup', label: 'TOP-UP' }
    ]

    this.productTypes = [
      { value: 'all', label: 'ALL' },
      { value: 'modem', label: 'MODEM' },
      { value: 'attraction', label: 'ATTRACTION' },
      { value: 'insurance', label: 'INSURANCE' },
      { value: 'inventory', label: 'ECOMMERCE' }
    ]

    this.state = {
      selectedProvider: null,
      coupon: {
        type: 'BUSINESS',
        title: '',
        code: '',
        tag: '',
        status: 'available',
        max_usage: 1,
        max_usage_per_user: 1,
        image_file: '',
        product_type: 'all',
        rent_type: 'all',
        travel_date_start: null,
        travel_date_end: null,
        min_duration: 0,
        discount_type: 'PRICE_CUT',
        discount_amount: 0,
        max_discount: 0,
        start_at: moment(),
        end_at: moment(),
        description: '',
        min_amount: 0,
        max_amount: 0,
        platform: 'all',
        first_order_only: false,
        first_user_only: false
      },
      count: 5
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  _selectChange = (selectedProvider) => {
    let coupon = { ...this.state.coupon }
    coupon.provider_id = selectedProvider.value
    this.setState({
      selectedProvider,
      coupon
    })
  }

  _fileUploaded = (filename, field) => {
    let coupon = { ...this.state.coupon }
    coupon[field] = filename
    this.setState({ coupon })
  }

  _couponChange = (event, field, isNumber = false) => {
    let val = event.target.value
    if (isNumber) {
      val = parseInt(val, 10)
    }
    let coupon = { ...this.state.coupon }
    coupon[field] = val
    if (field === 'tag') {
      if (val.match(this.couponCodeRegex) === null) {
        return null
      }
      coupon[field] = val.substr(0, 14)
      coupon['code'] = coupon[field] + '-'
    }
    this.setState({ coupon })
  }

  _dateChange = (date, field) => {
    let coupon = { ...this.state.coupon }
    coupon[field] = date
    this.setState({ coupon })
  }

  _submit = (event) => {
    event.preventDefault()
    const preset = 'GENERATE_DUPLICATES_WITH_APPENDED_CODE'
    let baseCoupon = { ...this.state.coupon }
    baseCoupon['start_at'] = this.state.coupon.start_at.format()
    baseCoupon['end_at'] = this.state.coupon.end_at.format()
    const options = {
      appendedCodeLength: 6
    }

    const data = {
      preset,
      count: this.state.count,
      baseCoupon,
      options
    }

    this.props.createCoupon(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    const { couponProvider } = this.props

    let providerPicker = []
    couponProvider.data && couponProvider.data.map((item, i) => (
      providerPicker[i] = {
        value: item.id,
        label: item.name
      }
    ))

    return (
      <section className='section' style={{ width: '85vw' }}>
        <div className='title-block'>
          <h3 className='title'>Generate Coupon</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='row'>
            <div className='col-6'>
              <div className='section'>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Count</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' min={1} className='form-control' value={this.state.count} onChange={(event) => this.setState({ count: parseInt(event.target.value, 10) })} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Title</label>
                  </div>
                  <div className='col-9'>
                    <input type='text' required placeholder='Coupon Title' className='form-control' value={this.state.coupon.title} onChange={(event) => this._couponChange(event, 'title')} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Tag</label>
                  </div>
                  <div className='col-9'>
                    <input type='text' required placeholder='Coupon Code (max: 14 char)' className='form-control' value={this.state.coupon.tag} onChange={(event) => this._couponChange(event, 'tag')} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Status</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.status} className='form-control' onChange={(event) => this._couponChange(event, 'status')}>
                      <option value='available'>Available</option>
                      <option value='unavailable'>Unavailable</option>
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Platform</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.platform} className='form-control' onChange={(event) => this._couponChange(event, 'platform')}>
                      {this.platforms.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Product Type</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.product_type} className='form-control' onChange={(event) => this._couponChange(event, 'product_type')}>
                      {this.productTypes.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                    </select>
                  </div>
                </div>
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Rent Type</label>
                    </div>
                    <div className='col-9'>
                      <select value={this.state.coupon.rent_type} className='form-control' onChange={(event) => this._couponChange(event, 'rent_type')}>
                        {this.rentType.map((list, i) => <option key={i} value={list.value}>{ list.label }</option>)}
                      </select>
                    </div>
                  </div>
                }
                {
                  (this.state.coupon.product_type === 'modem' || this.state.coupon.product_type === 'all') &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Duration</label>
                    </div>
                    <div className='col-9'>
                      <input type='number' min={0} className='form-control' value={this.state.coupon.min_duration} onChange={(event) => this._couponChange(event, 'min_duration', true)} />
                    </div>
                  </div>
                }
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Travel Start</label>
                    </div>
                    <div className='col-9'>
                      <DateTime
                        dateFormat={this.dateFormat}
                        timeFormat={false}
                        utc
                        isValidDate={current => current.isSameOrAfter(moment().subtract(1, 'day'))}
                        value={this.state.coupon.travel_date_start}
                        onChange={(date) => this._dateChange(date, 'travel_date_start')}
                        closeOnSelect
                      />
                    </div>
                  </div>
                }
                {
                  this.state.coupon.product_type === 'modem' &&
                  <div className='form-group row'>
                    <div className='col-3'>
                      <label className='control-label'>Travel End</label>
                    </div>
                    <div className='col-9'>
                      <DateTime
                        dateFormat={this.dateFormat}
                        timeFormat={false}
                        utc
                        isValidDate={current => current.isAfter(this.state.coupon.travel_date_start)}
                        value={this.state.coupon.travel_date_end}
                        onChange={(date) => this._dateChange(date, 'travel_date_end')}
                        closeOnSelect
                      />
                    </div>
                  </div>
                }
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Usage</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' min={0} className='form-control' value={this.state.coupon.max_usage} onChange={(event) => this._couponChange(event, 'max_usage', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Usage Per User</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' min={0} className='form-control' value={this.state.coupon.max_usage_per_user} onChange={(event) => this._couponChange(event, 'max_usage_per_user', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Discount Type</label>
                  </div>
                  <div className='col-9'>
                    <select value={this.state.coupon.discount_type} className='form-control' onChange={(event) => this._couponChange(event, 'discount_type')}>
                      <option value='PRICE_CUT'>PRICE CUT</option>
                      <option value='FULL_CUT'>FULL CUT</option>
                      {
                        (this.state.coupon.product_type === 'modem' || this.state.coupon.product_type === 'all') &&
                        this.state.coupon.min_duration > 0 &&
                        <option value='DURATION_CUT'>FULL CUT (DURATION BASED)</option>
                      }
                      {
                        this.state.coupon.product_type === 'modem' &&
                        this.state.coupon.min_duration > 0 &&
                        <option value='FULL_CUT_WITH_DEPOSIT'>FULL CUT (WITH DEPOSIT)</option>
                      }
                      <option value='PERCENTAGE_CUT'>PERCENTAGE CUT</option>
                    </select>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Discount Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.discount_amount} onChange={(event) => this._couponChange(event, 'discount_amount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Discount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.max_discount} onChange={(event) => this._couponChange(event, 'max_discount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Min Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.min_amount} onChange={(event) => this._couponChange(event, 'min_amount', true)} />
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-3'>
                    <label className='control-label'>Max Amount</label>
                  </div>
                  <div className='col-9'>
                    <input type='number' className='form-control' value={this.state.coupon.max_amount} onChange={(event) => this._couponChange(event, 'max_amount', true)} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>First Order Only</label>
                </div>
                <div className='col-9'>
                  <SwitchButton isChecked={this.state.coupon.first_order_only} onChange={(event) => this._couponChange(event, 'first_order_only')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>First User Only</label>
                </div>
                <div className='col-9'>
                  <SwitchButton isChecked={this.state.coupon.first_user_only} onChange={(event) => this._couponChange(event, 'first_user_only')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Start At</label>
                </div>
                <div className='col-9'>
                  <DateTime
                    value={this.state.coupon.start_at}
                    viewDate={this.state.coupon.start_at}
                    onChange={(date) => this._dateChange(date, 'start_at')}
                    closeOnSelect
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>End At</label>
                </div>
                <div className='col-9'>
                  <DateTime
                    value={this.state.coupon.end_at}
                    viewDate={this.state.coupon.end_at}
                    onChange={(date) => this._dateChange(date, 'end_at')}
                    closeOnSelect
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Description</label>
                </div>
                <div className='col-9'>
                  <textarea placeholder='Coupon Description' rows='3' value={this.state.coupon.description} className='form-control' onChange={(event) => this._couponChange(event, 'description')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Coupon Provider</label>
                </div>
                <div className='col-9'>
                  <Select
                    options={providerPicker}
                    value={this.state.selectedProvider}
                    onChange={(selectedProvider) => this._selectChange(selectedProvider)}
                    required
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Image File (<span className='text-orange'>433x433</span>)</label>
                </div>
                <div className='col-9'>
                  <FileUploader setting={{ type: 'coupon-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files,
  couponProvider: state.couponProvider
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  createCoupon: (data) => dispatch(CouponActions.couponGenerateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(GenerateCoupon)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/GenerateCoupon.js